export default {
  categories: {
    loading: false,
    data: [],
    error: null,
  },
  modal: {
    open: false,
    service: null,
    editMedia: false,
  },
  reportModal: {
    open: false,
    service: null,
    type: null,
  },
  reportServiceOrComment: {
    loading: false,
    data: null,
    type: null,
    error: null,
  },
  editPricingModal: {
    open: false,
    service: null,
  },
  servicesList: {
    loading: false,
    data: {
      Meta: null,
      Data: null,
    },
    error: null,
  },

  service: {
    loading: false,
    data: {
      Meta: null,
      Data: null,
    },
    error: null,
  },

  createService: {
    loading: false,
    data: null,
    error: null,
  },

  bookMarkedServices: {
    loading: false,
    data: {
      Data: [],
    },
    error: null,
  },
  addBookMarkedService: {
    loading: false,
    data: null,
    error: null,
  },
  removeBookMarkedService: {
    loading: false,
    data: null,
    error: null,
  },

  deleteServiceComment: {
    loading: false,
    data: null,
    error: null,
  },

  deleteService: {
    loading: false,
    data: null,
    error: null,
  },

  myServices: {
    loading: false,
    data: null,
    error: null,
  },
  relatedServices: {
    loading: false,
    data: null,
    error: null,
  },

  setServiceStatus: {
    loading: false,
    data: null,
    error: null,
  },
  updateService: {
    loading: false,
    data: null,
    error: null,
  },
  updateServiceDetails: {
    loading: false,
    data: null,
    error: null,
  },
  updateServiceMedia: {
    loading: false,
    data: null,
    error: null,
  },
  addComment: {
    loading: false,
    data: null,
    error: null,
  },

  rateService: {
    loading: false,
    data: null,
    error: null,
  },

  likeService: {
    loading: false,
    data: null,
    error: null,
  },

  disLike: {
    loading: false,
    data: null,
    error: null,
  },

  deleteServiceModal: {
    open: false,
    service: null,
  },

  searchResults: {
    loading: false,
    data: {
      Meta: null,
      Data: null,
    },
    error: null,
  },
  serviceLinkMetaData: {
    loading: false,
    serviceId: null,
    data: null,
    error: null,
  },

  mobileLayout: {
    sidebarOpened: false,
  },

  desktopLayout: {
    navbarFixed: false,
  },
};
